import { History as HistoryIcon } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledButton } from '../../styles/StyledButtons';
import { StyledHeading } from '../../styles/styles';

export default function GlobalConfigAdminHeader() {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <StyledHeading tone="tone1" headerVariant="heading2">
          Global Configuration
        </StyledHeading>
        <StyledButton
          variant="outlined"
          startIcon={<HistoryIcon />}
          onClick={() => navigate('/activityLogs/GLOBAL_CONFIG/global')}
        >
          View Activity Log
        </StyledButton>
      </Stack>
    </Box>
  );
}
